import React from 'react'
import './UserFeedbackChart.css'

const UserFeedbackChart = ({ data }) => {
  // Calculate angles for pie chart
  const total = data.reduce((sum, item) => sum + item.value, 0)
  let currentAngle = 0
  
  const segments = data.map((item, index) => {
    const percentage = (item.value / total) * 100
    const angle = (item.value / total) * 360
    const startAngle = currentAngle
    const endAngle = currentAngle + angle
    currentAngle = endAngle
    
    // Calculate path for pie slice
    const radius = 60
    const centerX = 80
    const centerY = 80
    
    const startAngleRad = (startAngle - 90) * (Math.PI / 180)
    const endAngleRad = (endAngle - 90) * (Math.PI / 180)
    
    const x1 = centerX + radius * Math.cos(startAngleRad)
    const y1 = centerY + radius * Math.sin(startAngleRad)
    const x2 = centerX + radius * Math.cos(endAngleRad)
    const y2 = centerY + radius * Math.sin(endAngleRad)
    
    const largeArcFlag = angle > 180 ? 1 : 0
    
    const pathData = [
      `M ${centerX} ${centerY}`,
      `L ${x1} ${y1}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
      'Z'
    ].join(' ')
    
    return {
      ...item,
      pathData,
      percentage: Math.round(percentage)
    }
  })

  return (
    <div className="chart-card">
      <h2 className="chart-title">User Feedback</h2>
      <div className="pie-chart-container">
        <svg viewBox="0 0 160 160" className="pie-chart-svg">
          {segments.map((segment, index) => (
            <path
              key={index}
              d={segment.pathData}
              fill={segment.color}
              stroke="#ffffff"
              strokeWidth="2"
            />
          ))}
        </svg>
        <div className="pie-chart-legend">
          {segments.map((segment, index) => (
            <div key={index} className="legend-item">
              <span 
                className="legend-color" 
                style={{ backgroundColor: segment.color }}
              ></span>
              <span className="legend-label">{segment.label}</span>
              <span className="legend-percentage">{segment.percentage}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default UserFeedbackChart













